export default "__VITE_ASSET__kKk7l$DL__"